import { API } from './apiWrapper';

import { useMutation } from './useMutation';

export const saveAIForm = async (formData: any) => {
  const data = await API.post('AiFormRequest', '/save?key=update', {
    body: formData,
  });
  return data;
};

export const useSaveAIForm = () => {
  return useMutation({ mutate: saveAIForm });
};
